import React, {
  useCallback,
  useMemo,
  useState,
  useRef,
  useEffect,
} from "react";
import { Platform } from "react-native";
import {
  Box,
  VStack,
  HStack,
  Text,
  Center,
  Input,
  Image,
  Stack,
  ScrollView,
  Pressable,
  Button,
  Spinner,
  IconButton,
  ChevronUpIcon,
  useToast,
  Icon,
  Select,
  CheckIcon,
} from "native-base";
import { LinearGradient } from "expo-linear-gradient";
import { DatePickerModal } from "react-native-paper-dates";
import { SafeAreaProvider } from "react-native-safe-area-context";
import { Ionicons } from "@expo/vector-icons";
import { GlobalStyles } from "../../constants/styles";
import { GlobalConstants } from "../../constants/constants";
import { useSelector } from "react-redux";
import axios from "axios";
import Toast from "../Toast";

// const buildApiUrl = (baseUrl, port, endpoint) => {
//   const cleanBaseUrl = baseUrl.endsWith("/") ? baseUrl.slice(0, -1) : baseUrl;
//   return `${cleanBaseUrl}:${port}${endpoint}`;
// };

// const apiBaseUrl = buildApiUrl(
//   GlobalConstants.servicesBaseUrl,
//   "3001",
//   "/api/ticket",
// );
const TicketsBASEURL = GlobalConstants.ticketsBaseUrl; // "https://tickets.townticks.com/"
const apiBaseUrl = `${TicketsBASEURL}api/ticket`;

const leftArrow = require("../../../assets/leftarrowblack.png");
const rightArrow = require("../../../assets/rightarrowblack.png");
const calendarIcon = require("../../../assets/calendericon.png");
const analyticsIcon = require("../../../assets/analyticsGrapghImage.png");
const verifyIcon = require("../../../assets/verifyTicket.png");

const formatDateMMDDYYYY = (date) => {
  if (!date) return "";
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  const padNumber = (num) => (num < 10 ? "0" + num : String(num));
  return `${padNumber(month)}/${padNumber(day)}/${year}`;
};



const GradientButton = ({
  title,
  onPress,
  width = 192,
  height = 36,
  isLoading = false,
}) => {
  const buttonStyle = {
    width,
    height,
    alignItems: "center",
    justifyContent: "center",
  };

  const pressableStyle = {
    width: "100%",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
  };

  return (
    <Box
      borderRadius={5}
      overflow="hidden"
      borderWidth={1}
      borderColor={GlobalStyles.colors.black}
      style={{ width, height }}
    >
      <LinearGradient
        colors={[
          GlobalStyles.colors.gradientBlueStart || "#000561",
          GlobalStyles.colors.gradientBlueEnd || "#000AC7",
        ]}
        start={{ x: 0, y: 0 }}
        end={{ x: 1, y: 0 }}
        style={buttonStyle}
      >
        <Pressable
          onPress={onPress}
          disabled={isLoading}
          style={pressableStyle}
        >
          {isLoading ? (
            <Spinner color={GlobalStyles.colors.mustard} />
          ) : (
            <Text
              color={GlobalStyles.colors.mustard}
              fontWeight="600"
              fontSize="15px"
              letterSpacing="0.1px"
              fontFamily={GlobalStyles.text.fontFamily}
            >
              {title}
            </Text>
          )}
        </Pressable>
      </LinearGradient>
    </Box>
  );
};

const MiniDeleteButton = ({ title = "Delete", onPress, isLoading = false }) => {
  const gradientStyle = {
    paddingHorizontal: 12,
    paddingVertical: 8,
  };

  return (
    <Box
      borderRadius={8}
      overflow="hidden"
      borderWidth={1}
      borderColor={GlobalStyles.colors.black}
    >
      <LinearGradient
        colors={[
          GlobalStyles.colors.gradientBlueStart,
          GlobalStyles.colors.gradientBlueEnd,
        ]}
        start={{ x: 0, y: 0 }}
        end={{ x: 1, y: 0 }}
        style={gradientStyle}
      >
        <Pressable onPress={onPress} disabled={isLoading}>
          {isLoading ? (
            <Spinner size="sm" color={GlobalStyles.colors.mustard} />
          ) : (
            <Text
              color={GlobalStyles.colors.mustard}
              fontWeight="700"
              fontSize={14}
              letterSpacing={0.2}
              fontFamily={GlobalStyles.text.fontFamily}
            >
              {title}
            </Text>
          )}
        </Pressable>
      </LinearGradient>
    </Box>
  );
};

const TicketCreate = ({ onCreated }) => {
  const toast = useToast();
  const user = useSelector((state) => state.user?.user);

  const [ticketName, setTicketName] = useState("");
  const [ticketCount, setTicketCount] = useState(5);
  const [ticketValueUSD, setTicketValueUSD] = useState("5");
  const [ticketValueLocal, setTicketValueLocal] = useState("18.35");
  const [currency, setCurrency] = useState("AED");
  const [expiryDate, setExpiryDate] = useState("");
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const conversionRates = {
    AED: 3.67, // 1 USD = 3.67 AED
    CAD: 1.35, // 1 USD = 1.35 CAD
  };

  //company name from redux profile 
  const companyName = user?.profile?.name ||
    user?.business_name ||
    user?.name ||
    user?.email?.split("@")[0] ||
    "Unknown Company";

  useEffect(() => {
    if (user?.token) {
      axios.defaults.headers.common = {
        Authorization: `Bearer ${user.token}`,
      };
    }
  }, [user]);

  const handleUSDChange = (value) => {
    setTicketValueUSD(value);
    const numValue = parseFloat(value);
    if (!isNaN(numValue) && numValue >= 0) {
      const converted = (numValue * conversionRates[currency]).toFixed(2);
      setTicketValueLocal(converted);
    }
  };

  // Handle currency change
  const handleCurrencyChange = (newCurrency) => {
    setCurrency(newCurrency);
    const usdValue = parseFloat(ticketValueUSD);
    if (!isNaN(usdValue) && usdValue >= 0) {
      const converted = (usdValue * conversionRates[newCurrency]).toFixed(2);
      setTicketValueLocal(converted);
    }
  };

  const createTicket = useCallback(async () => {
    if (!ticketName.trim()) {
      toast.show({
        render: () => (
          <Toast
            color={GlobalStyles.colors.red}
            message="Enter a ticket name"
          />
        ),
        placement: "top",
        duration: 2000,
      });
      return;
    }

    if (ticketCount < 1) {
      toast.show({
        render: () => (
          <Toast
            color={GlobalStyles.colors.red}
            message="Ticket count must be at least 1"
          />
        ),
        placement: "top",
        duration: 2000,
      });
      return;
    }

    const usdValue = parseFloat(ticketValueUSD);
    const localValue = parseFloat(ticketValueLocal);

    if (isNaN(usdValue) || usdValue < 0) {
      toast.show({
        render: () => (
          <Toast
            color={GlobalStyles.colors.red}
            message="Enter a valid USD value"
          />
        ),
        placement: "top",
        duration: 2000,
      });
      return;
    }

    if (isNaN(localValue) || localValue < 0) {
      toast.show({
        render: () => (
          <Toast
            color={GlobalStyles.colors.red}
            message="Enter a valid local currency value"
          />
        ),
        placement: "top",
        duration: 2000,
      });
      return;
    }

    if (!expiryDate) {
      toast.show({
        render: () => (
          <Toast
            color={GlobalStyles.colors.red}
            message="Select an expiry date"
          />
        ),
        placement: "top",
        duration: 2000,
      });
      return;
    }

    try {
      setIsLoading(true);
      const dateParts = expiryDate.split("/");
      let expiryISO;
      if (dateParts.length === 3) {
        const [month, day, year] = dateParts;
        expiryISO = new Date(`${year}-${month}-${day}`).toISOString();
      } else {
        expiryISO = new Date(
          Date.now() + 30 * 24 * 60 * 60 * 1000,
        ).toISOString();
      }

      const ticketData = {
        name: ticketName.trim(),
        company_name: companyName,
        ticket_type: ticketName.trim(),
        total_tickets: ticketCount,
        total_available: ticketCount,
        ticket_value: Math.round(usdValue),
        ticket_value_usd: usdValue,
        ticket_value_local: localValue,
        currency: currency,
        expiry_date: expiryISO,
      };

      const apiClient = axios.create({
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
        timeout: 10000,
      });

      const response = await apiClient.post(apiBaseUrl, ticketData);

      if (response.data.ticket) {
        toast.show({
          render: () => (
            <Toast
              color={GlobalStyles.colors.mustard}
              message="Ticket created successfully!"
            />
          ),
          placement: "top",
          duration: 2000,
        });

        const createdTicket = {
          id: response.data.ticket.id,
          name: response.data.ticket.name,
          title: response.data.ticket.name,
          companyName: response.data.ticket.company_name || companyName,
          count: response.data.ticket.total_tickets,
          value: response.data.ticket.ticket_value,
          valueUSD: response.data.ticket.ticket_value_usd,
          valueLocal: response.data.ticket.ticket_value_local,
          currency: response.data.ticket.currency,
          expiry: response.data.ticket.expiry_date,
          created: response.data.ticket.total_tickets,
          used:
            response.data.ticket.total_tickets -
            response.data.ticket.total_available,
          qrCode: response.data.qrCode || response.data.ticket.qr_code,
        };

        if (onCreated) {
          onCreated(createdTicket);
        }

        setTicketName("");
        setTicketCount(5);
        setTicketValueUSD("5");
        setTicketValueLocal("5");
        setCurrency("AED");
        setExpiryDate("");
      }
    } catch (error) {
      console.error("Error creating ticket:", error);

      let errorMessage = "Failed to create ticket";

      if (error.code === "ECONNABORTED" || error.message?.includes("timeout")) {
        errorMessage = "Server not responding.try again.";
      } else if (!error.response && !error.request) {
        errorMessage = "Network error. Check your connection.";
      } else if (error.code === "ERR_NETWORK") {
        errorMessage = "Cannot connect to server.";
      } else if (error.response) {
        errorMessage =
          error.response?.data?.errors?.[0]?.msg ||
          error.response?.data?.message ||
          `Server error: ${error.response.status}`;
      }

      toast.show({
        render: () => (
          <Toast color={GlobalStyles.colors.red} message={errorMessage} />
        ),
        placement: "top",
        duration: 2500,
      });
    } finally {
      setIsLoading(false);
    }
  }, [ticketName, ticketCount, ticketValueUSD, ticketValueLocal, currency, expiryDate, user, companyName, onCreated, toast]);

  return (
    <SafeAreaProvider>
      <VStack w="100%" space={4}>
        <Center w="100%">
          <VStack space={6} w={["90%", "85%", "650px"]} px={[4, 6, 6]}>
            <Box>
              <Text
                fontWeight="400"
                mb={2}
                color={GlobalStyles.colors.black}
                fontFamily={GlobalStyles.text.fontFamily}
                fontSize={["14px", "15px", "16px"]}
              >
                Enter Ticket Name *
              </Text>
              <Input
                value={ticketName}
                onChangeText={setTicketName}
                borderColor={GlobalStyles.colors.mustard}
                borderWidth={1}
                borderRadius={6}
                bg={GlobalStyles.colors.white}
                _focus={{ borderColor: GlobalStyles.colors.mustard }}
                fontFamily={GlobalStyles.text.fontFamily}
                fontSize={["sm", "md", "md"]}
                py={3}
                placeholder="Enter ticket name"
              />
              <Text
                fontSize={["11px", "12px", "12px"]}
                fontWeight="300"
                lineHeight="20px"
                letterSpacing="0.1px"
                fontFamily={GlobalStyles.text.fontFamily}
                color={GlobalStyles.colors.black}
                mt={2}
              >
                Tip: If there are multiple ticket types, mention in name, like
                silver, gold, premium etc.
              </Text>
            </Box>

            <HStack alignItems="center" justifyContent="space-between">
              <Text
                fontWeight="400"
                color={GlobalStyles.colors.black}
                fontFamily={GlobalStyles.text.fontFamily}
                fontSize={["14px", "15px", "16px"]}
              >
                How many Tickets
              </Text>
              <HStack alignItems="center" space={3}>
                <Pressable
                  onPress={() => setTicketCount((c) => Math.max(1, c - 1))}
                >
                  <Image
                    source={leftArrow}
                    alt="-"
                    style={{ width: 18, height: 18 }}
                  />
                </Pressable>
                <Box
                  bg={GlobalStyles.colors.white}
                  borderWidth={1}
                  borderColor={GlobalStyles.colors.black}
                  borderRadius={10}
                  w={[40, 45, 45]}
                  h={29}
                  alignItems="center"
                  justifyContent="center"
                >
                  <Text
                    fontSize="md"
                    fontWeight="700"
                    color={GlobalStyles.colors.black}
                    fontFamily={GlobalStyles.text.fontFamily}
                  >
                    {ticketCount}
                  </Text>
                </Box>
                <Pressable onPress={() => setTicketCount((c) => c + 1)}>
                  <Image
                    source={rightArrow}
                    alt="+"
                    style={{ width: 18, height: 18 }}
                  />
                </Pressable>
              </HStack>
            </HStack>

            <HStack alignItems="center" justifyContent="space-between">
              <Text
                fontWeight="400"
                color={GlobalStyles.colors.black}
                fontFamily={GlobalStyles.text.fontFamily}
                fontSize={["14px", "15px", "16px"]}
              >
                Ticket Value (USD)
              </Text>
              <Input
                value={ticketValueUSD}
                onChangeText={handleUSDChange}
                borderColor={GlobalStyles.colors.black}
                borderWidth={1}
                borderRadius={10}
                bg={GlobalStyles.colors.white}
                _focus={{ borderColor: GlobalStyles.colors.black }}
                fontFamily={GlobalStyles.text.fontFamily}
                fontSize="md"
                fontWeight="700"
                textAlign="center"
                w={[80, 90, 100]}
                h={29}
                py={0}
                px={2}
                placeholder="0.00"
                keyboardType="decimal-pad"
              />
            </HStack>

            <HStack alignItems="center" justifyContent="space-between">
              <Text
                fontWeight="400"
                color={GlobalStyles.colors.black}
                fontFamily={GlobalStyles.text.fontFamily}
                fontSize={["14px", "15px", "16px"]}
              >
                Currency
              </Text>
              <Select
                selectedValue={currency}
                minWidth={[80, 90, 100]}
                h={29}
                accessibilityLabel="Choose Currency"
                placeholder="Currency"
                _selectedItem={{
                  bg: "teal.600",
                  endIcon: <CheckIcon size="5" />,
                }}
                onValueChange={handleCurrencyChange}
                borderColor={GlobalStyles.colors.black}
                borderWidth={1}
                borderRadius={10}
                bg={GlobalStyles.colors.white}
                _focus={{ borderColor: GlobalStyles.colors.black }}
                fontFamily={GlobalStyles.text.fontFamily}
                fontSize="md"
                fontWeight="700"
                py={0}
              >
                <Select.Item label="AED" value="AED" />
                <Select.Item label="CAD" value="CAD" />
              </Select>
            </HStack>

            <HStack alignItems="center" justifyContent="space-between">
              <Text
                fontWeight="400"
                color={GlobalStyles.colors.black}
                fontFamily={GlobalStyles.text.fontFamily}
                fontSize={["14px", "15px", "16px"]}
              >
                Value ({currency})
              </Text>
              <Input
                value={ticketValueLocal}
                onChangeText={setTicketValueLocal}
                borderColor={GlobalStyles.colors.black}
                borderWidth={1}
                borderRadius={10}
                bg={GlobalStyles.colors.white}
                _focus={{ borderColor: GlobalStyles.colors.black }}
                fontFamily={GlobalStyles.text.fontFamily}
                fontSize="md"
                fontWeight="700"
                textAlign="center"
                w={[80, 90, 100]}
                h={29}
                py={0}
                px={2}
                placeholder="0.00"
                keyboardType="decimal-pad"
              />
            </HStack>

            <Stack
              flexDirection={window?.innerWidth < 415 ? "column" : "row"}
              alignItems={window?.innerWidth < 415 ? "flex-start" : "center"}
              justifyContent="space-between"
              space={window?.innerWidth < 415 ? 2 : 0}
            >
              <Text
                fontWeight="400"
                color={GlobalStyles.colors.black}
                fontFamily={GlobalStyles.text.fontFamily}
                fontSize={["14px", "15px", "16px"]}
              >
                Ticket Expiry Date *
              </Text>
              <Input
                w={window?.innerWidth < 415 ? "100%" : ["60%", "60%", "60%"]}
                borderColor={GlobalStyles.colors.mustard}
                borderWidth={1}
                borderRadius={6}
                bg={GlobalStyles.colors.white}
                placeholder="MM/DD/YYYY"
                value={expiryDate}
                isReadOnly
                InputRightElement={
                  <Pressable onPress={() => setShowDatePicker(true)}>
                    <Box mr={2}>
                      <Image
                        source={calendarIcon}
                        alt="Calendar"
                        style={{ width: 18, height: 18 }}
                      />
                    </Box>
                  </Pressable>
                }
                _focus={{ borderColor: GlobalStyles.colors.mustard }}
                fontFamily={GlobalStyles.text.fontFamily}
              />
            </Stack>

            <SafeAreaProvider>
              <DatePickerModal
                locale="en"
                mode="single"
                visible={showDatePicker}
                onDismiss={() => setShowDatePicker(false)}
                date={expiryDate ? new Date(expiryDate) : undefined}
                onConfirm={(params) => {
                  const { date } = params;
                  if (date) {
                    setExpiryDate(formatDateMMDDYYYY(date));
                  }
                  setShowDatePicker(false);
                }}
                validRange={{
                  startDate: new Date(),
                  endDate: new Date(2100, 11, 31),
                }}
              />
            </SafeAreaProvider>

            <Box alignItems="center" mt={2}>
              <GradientButton
                title="Generate Ticket"
                onPress={createTicket}
                width={150}
                height={40}
                isLoading={isLoading}
              />
            </Box>
          </VStack>
        </Center>
      </VStack>
    </SafeAreaProvider>
  );
};

const TicketGenerated = ({ ticket, onHome }) => {
  if (!ticket) return null;

  const boxShadowWeb = { boxShadow: "0px 4px 4px 0px #00000040" };
  const boxShadowNative = {
    shadowColor: GlobalStyles.colors.black,
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 4,
  };

  const imageStyle = { width: "90%", height: "90%" };

  return (
    <VStack w="100%" space={4}>
      <Center w="100%">
        <Box
          w={["90%", 350, 387]}
          h={[300, 320, 335]}
          borderRadius={12}
          bg={GlobalStyles.colors.white}
          alignItems="center"
          pt={4}
          style={Platform.OS === "web" ? boxShadowWeb : boxShadowNative}
        >
          <Center
            w={[90, 100, 100]}
            h={[90, 100, 100]}
            bg={GlobalStyles.colors.black}
            borderRadius={4}
          >
            {ticket.qrCode ? (
              <Image
                source={{ uri: ticket.qrCode }}
                alt="QR Code"
                style={imageStyle}
                resizeMode="contain"
              />
            ) : (
              <Text
                color={GlobalStyles.colors.white}
                fontWeight="600"
                fontFamily={GlobalStyles.text.fontFamily}
              >
                QR
              </Text>
            )}
          </Center>

          <VStack mt={5} space={3} w="80%">
            <HStack justifyContent="space-between">
              <Text
                fontFamily={GlobalStyles.text.fontFamily}
                fontSize={["13px", "14px", "15px"]}
              >
                Ticket Name:
              </Text>
              <Text
                numberOfLines={1}
                fontFamily={GlobalStyles.text.fontFamily}
                fontSize={["13px", "14px", "15px"]}
              >
                {ticket.name}
              </Text>
            </HStack>
            <HStack justifyContent="space-between">
              <Text
                fontFamily={GlobalStyles.text.fontFamily}
                fontSize={["13px", "14px", "15px"]}
              >
                Company:
              </Text>
              <Text
                numberOfLines={1}
                fontFamily={GlobalStyles.text.fontFamily}
                fontSize={["13px", "14px", "15px"]}
              >
                {ticket.companyName}
              </Text>
            </HStack>

            <HStack justifyContent="space-between">
              <Text
                fontFamily={GlobalStyles.text.fontFamily}
                fontSize={["13px", "14px", "15px"]}
              >
                Ticket ID:
              </Text>
              <Text
                numberOfLines={1}
                fontFamily={GlobalStyles.text.fontFamily}
                fontSize={["13px", "14px", "15px"]}
              >
                {ticket.id}
              </Text>
            </HStack>

            <HStack justifyContent="space-between">
              <Text
                fontFamily={GlobalStyles.text.fontFamily}
                fontSize={["13px", "14px", "15px"]}
              >
                Value (USD):
              </Text>
              <Text
                numberOfLines={1}
                fontFamily={GlobalStyles.text.fontFamily}
                fontSize={["13px", "14px", "15px"]}
              >
                ${ticket.valueUSD || ticket.value}
              </Text>
            </HStack>

            {ticket.currency && ticket.valueLocal && (
              <HStack justifyContent="space-between">
                <Text
                  fontFamily={GlobalStyles.text.fontFamily}
                  fontSize={["13px", "14px", "15px"]}
                >
                  Value ({ticket.currency}):
                </Text>
                <Text
                  numberOfLines={1}
                  fontFamily={GlobalStyles.text.fontFamily}
                  fontSize={["13px", "14px", "15px"]}
                >
                  {ticket.valueLocal}
                </Text>
              </HStack>
            )}
          </VStack>
        </Box>
      </Center>
    </VStack>
  );
};

const TicketBarChart = ({ created = 95, used = 54, maxY = 120 }) => {
  const yAxisLabels = [120, 100, 80, 60, 40, 20, 0];
  const getValidValue = (num) => Math.max(0, Math.min(maxY, num));
  const createdPercent = (getValidValue(created) / maxY) * 100;
  const usedPercent = (getValidValue(used) / maxY) * 100;

  return (
    <Box w="100%" alignItems="center" px={[2, 4, 4]}>
      <Box w="100%" maxW={[340, 420, 460]}>
        <Text
          color={GlobalStyles.colors.black}
          fontWeight="700"
          fontSize={[13, 14, 14]}
          mb={3}
          fontFamily={GlobalStyles.text.fontFamily}
        >
          Tickets Issued and Used
        </Text>

        <HStack w="100%" alignItems="stretch" space={[2, 3, 3]}>
          <VStack
            w={[30, 36, 36]}
            justifyContent="space-between"
            h={[220, 260, 260]}
          >
            {yAxisLabels.map((label) => (
              <Text
                key={label}
                fontSize={[10, 11, 11]}
                color={GlobalStyles.colors.black}
                fontFamily={GlobalStyles.text.fontFamily}
              >
                {label}
              </Text>
            ))}
          </VStack>

          <Box flex={1} position="relative" h={[220, 260, 260]}>
            {yAxisLabels.map((yValue) => (
              <Box
                key={yValue}
                position="absolute"
                left={0}
                right={0}
                top={`calc(${(1 - yValue / maxY) * 100}% - 0.5px)`}
                h="1px"
                bg={GlobalStyles.colors.black}
              />
            ))}

            <HStack
              position="absolute"
              left={0}
              right={0}
              bottom="28px"
              alignItems="flex-end"
              justifyContent="center"
              space={[6, 8, 10]}
              h="calc(100% - 28px)"
            >
              <Box
                w={[70, 80, 90]}
                h={`${createdPercent}%`}
                bg={GlobalStyles.colors.gradientBlueEnd}
                borderColor={GlobalStyles.colors.black}
                borderWidth={1}
              />
              <Box
                w={[70, 80, 90]}
                h={`${usedPercent}%`}
                bg={GlobalStyles.colors.statGradientBottom}
                borderColor={GlobalStyles.colors.black}
                borderWidth={1}
              />
            </HStack>

            <HStack
              position="absolute"
              bottom={0}
              left={0}
              right={0}
              justifyContent="center"
              space={[4, 6, 8]}
            >
              <HStack space={2} alignItems="center">
                <Box
                  w="14px"
                  h="14px"
                  bg={GlobalStyles.colors.gradientBlueEnd}
                  borderColor={GlobalStyles.colors.black}
                  borderWidth={1}
                />
                <Text
                  fontSize={[11, 12, 12]}
                  color={GlobalStyles.colors.black}
                  fontFamily={GlobalStyles.text.fontFamily}
                >
                  Created
                </Text>
              </HStack>
              <HStack space={2} alignItems="center">
                <Box
                  w="14px"
                  h="14px"
                  bg={GlobalStyles.colors.statGradientBottom}
                  borderColor={GlobalStyles.colors.black}
                  borderWidth={1}
                />
                <Text
                  fontSize={[11, 12, 12]}
                  color={GlobalStyles.colors.black}
                  fontFamily={GlobalStyles.text.fontFamily}
                >
                  Used
                </Text>
              </HStack>
            </HStack>
          </Box>
        </HStack>
      </Box>
    </Box>
  );
};

const TicketAnalytics = ({ tickets = [], onHome }) => {
  const [showDetails, setShowDetails] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);

  const ticketRows = useMemo(
    () =>
      tickets.map((ticket) => ({
        id: ticket.id,
        title: ticket.title || ticket.name,
        created: ticket.created ?? 95,
        used: ticket.used ?? 54,
      })),
    [tickets],
  );

  const viewDetails = (ticket) => {
    setSelectedTicket(ticket);
    setShowDetails(true);
  };

  const boxShadowWeb = { boxShadow: "0px 6px 10px rgba(0,0,0,0.12)" };
  const boxShadowNative = {
    shadowColor: GlobalStyles.colors.black,
    shadowOffset: { width: 0, height: 6 },
    shadowOpacity: 0.12,
    shadowRadius: 10,
    elevation: 5,
  };

  const detailBoxShadowWeb = { boxShadow: "0px 4px 4px 0px #00000040" };
  const detailBoxShadowNative = {
    shadowColor: GlobalStyles.colors.black,
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 4,
  };

  const imageStyle = {
    width: 64,
    height: 44,
    borderRadius: 8,
  };

  return (
    <Box flex={1} w="100%">
      <VStack w="100%" space={4}>
        <Center>
          <Stack mt={6} w={["92%", "85%", 850]} alignItems="center">
            <Text
              color={GlobalStyles.colors.blue}
              fontWeight="600"
              fontSize={[18, 20, 22]}
              textAlign="center"
              mb={4}
              fontFamily={GlobalStyles.text.fontFamily}
            >
              Ticket Analytics
            </Text>

            {!showDetails && (
              <Box w="100%" maxW="650px" mb={6}>
                <Box
                  bg={GlobalStyles.colors.white}
                  borderRadius={12}
                  px={4}
                  py={4}
                  style={Platform.OS === "web" ? boxShadowWeb : boxShadowNative}
                >
                  <HStack justifyContent="space-between" px={1} mb={3}>
                    <Text
                      color={GlobalStyles.colors.black}
                      fontWeight="700"
                      fontSize={[13, 14, 14]}
                      fontFamily={GlobalStyles.text.fontFamily}
                    >
                      Current Tickets
                    </Text>
                    <Text
                      color={GlobalStyles.colors.black}
                      fontWeight="700"
                      fontSize={[13, 14, 14]}
                      fontFamily={GlobalStyles.text.fontFamily}
                    >
                      Stats
                    </Text>
                  </HStack>

                  {ticketRows.length === 0 ? (
                    <Center py={6}>
                      <Text
                        color="gray.500"
                        fontFamily={GlobalStyles.text.fontFamily}
                      >
                        No tickets available
                      </Text>
                    </Center>
                  ) : (
                    <VStack space={0}>
                      {ticketRows.map((ticket, index) => (
                        <Box key={ticket.id || ticket.title}>
                          <Pressable onPress={() => viewDetails(ticket)}>
                            <HStack
                              py={4}
                              alignItems="center"
                              justifyContent="space-between"
                            >
                              <Text
                                color={GlobalStyles.colors.black}
                                fontSize={[13, 14, 14]}
                                fontFamily={GlobalStyles.text.fontFamily}
                              >
                                {ticket.title}
                              </Text>
                              <Pressable onPress={() => viewDetails(ticket)}>
                                <Image
                                  source={analyticsIcon}
                                  alt="stats"
                                  style={imageStyle}
                                />
                              </Pressable>
                            </HStack>
                          </Pressable>
                          {index < ticketRows.length - 1 && (
                            <Box
                              w="100%"
                              h="1px"
                              bg={GlobalStyles.colors.black}
                              opacity={0.2}
                            />
                          )}
                        </Box>
                      ))}
                    </VStack>
                  )}
                </Box>
              </Box>
            )}

            {showDetails && (
              <VStack w="100%" maxW="680px" space={4} alignItems="center">
                <Box
                  w="100%"
                  bg={GlobalStyles.colors.white}
                  borderRadius={12}
                  px={4}
                  py={4}
                  style={
                    Platform.OS === "web"
                      ? detailBoxShadowWeb
                      : detailBoxShadowNative
                  }
                >
                  <TicketBarChart
                    created={selectedTicket?.created ?? 95}
                    used={selectedTicket?.used ?? 54}
                    maxY={120}
                  />
                  <Pressable onPress={() => setShowDetails(false)} mt={4}>
                    <Text
                      color={GlobalStyles.colors.blue}
                      underline
                      fontFamily={GlobalStyles.text.fontFamily}
                      fontSize={[13, 14, 15]}
                    >
                      Back to list
                    </Text>
                  </Pressable>
                </Box>
              </VStack>
            )}
          </Stack>
        </Center>
      </VStack>
    </Box>
  );
};

const TicketDelete = ({ tickets = [], onDeleted, onHome }) => {
  const toast = useToast();
  const user = useSelector((state) => state.user?.user);
  const [deletingId, setDeletingId] = useState(null);

  useEffect(() => {
    if (user?.token) {
      axios.defaults.headers.common = {
        Authorization: `Bearer ${user.token}`,
      };
    }
  }, [user]);

  const handleDelete = async (ticketId) => {
    try {
      setDeletingId(ticketId);

      const apiClient = axios.create({
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
        timeout: 8000,
      });

      await apiClient.delete(`${apiBaseUrl}/${ticketId}`);

      toast.show({
        render: () => (
          <Toast
            color={GlobalStyles.colors.mustard}
            message="Ticket deleted successfully!"
          />
        ),
        placement: "top",
        duration: 2000,
      });

      if (onDeleted) {
        onDeleted(ticketId);
      }
    } catch (error) {
      console.error("Error deleting ticket:", error);

      let errorMessage = "Failed to delete ticket";

      if (error.code === "ECONNABORTED" || error.message?.includes("timeout")) {
        errorMessage = "Server not responding. Please try again.";
      } else if (error.code === "ERR_NETWORK" || !error.response) {
        errorMessage = "Cannot connect to server.";
      } else if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      }

      toast.show({
        render: () => (
          <Toast color={GlobalStyles.colors.red} message={errorMessage} />
        ),
        placement: "top",
        duration: 2000,
      });
    } finally {
      setDeletingId(null);
    }
  };

  return (
    <Box w="100%">
      <VStack w="100%" space={4}>
        <Center>
          <VStack w={["92%", "85%", "650px"]} px={[4, 6, 6]} py={2} space={4}>
            <Text
              color={GlobalStyles.colors.blue}
              fontWeight="600"
              fontSize={[18, 20, 22]}
              textAlign="center"
              mt={2}
              mb={2}
              fontFamily={GlobalStyles.text.fontFamily}
            >
              Delete Tickets
            </Text>
            <Text
              color={GlobalStyles.colors.black}
              fontWeight="700"
              fontSize={[15, 16, 16]}
              ml={1}
              mt={2}
              fontFamily={GlobalStyles.text.fontFamily}
            >
              Current Tickets
            </Text>
            <Box
              bg={GlobalStyles.colors.white}
              borderRadius={12}
              px={4}
              py={4}
              style={
                Platform.OS === "web"
                  ? { boxShadow: "0px 4px 4px 0px #00000040" }
                  : {
                      shadowColor: "#000",
                      shadowOffset: { width: 0, height: 4 },
                      shadowOpacity: 0.25,
                      shadowRadius: 4,
                      elevation: 4,
                    }
              }
            >
              {tickets.length === 0 ? (
                <Center py={6}>
                  <Text
                    color="gray.500"
                    fontFamily={GlobalStyles.text.fontFamily}
                  >
                    No tickets to delete.
                  </Text>
                </Center>
              ) : (
                <VStack space={6}>
                  {tickets.map((ticket) => (
                    <HStack
                      key={ticket.id}
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      <Text
                        color={GlobalStyles.colors.black}
                        fontSize={[14, 15, 16]}
                        fontFamily={GlobalStyles.text.fontFamily}
                      >
                        {ticket.title || ticket.name}
                      </Text>
                      <MiniDeleteButton
                        title="Delete"
                        onPress={() => handleDelete(ticket.id)}
                        isLoading={deletingId === ticket.id}
                      />
                    </HStack>
                  ))}
                </VStack>
              )}
            </Box>
          </VStack>
        </Center>
      </VStack>
    </Box>
  );
};

const TicketVerify = ({ onHome }) => {
  const toast = useToast();
  const user = useSelector((state) => state.user?.user);
  const [ticketId, setTicketId] = useState("");
  const [ticketData, setTicketData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const fetchTicketStatus = async () => {
    if (!ticketId.trim()) {
      toast.show({
        render: () => (
          <Toast
            color={GlobalStyles.colors.red}
            message="Enter a ticket ID"
          />
        ),
        placement: "top",
        duration: 2000,
      });
      return;
    }

    setIsLoading(true);
    try {
      const apiClient = axios.create({
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
        timeout: 8000,
      });

      const response = await apiClient.get(`${apiBaseUrl}/${ticketId.trim()}/status`);

      if (response.data) {
        setTicketData(response.data);
        toast.show({
          render: () => (
            <Toast
              color={GlobalStyles.colors.green}
              message="Ticket found!"
            />
          ),
          placement: "top",
          duration: 2000,
        });
      }
    } catch (error) {
      console.error("Error fetching ticket status:", error);
      let errorMessage = "Failed to fetch ticket status";

      if (error.response?.status === 404) {
        errorMessage = "Ticket not found";
      } else if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      }

      toast.show({
        render: () => (
          <Toast color={GlobalStyles.colors.red} message={errorMessage} />
        ),
        placement: "top",
        duration: 2000,
      });
      setTicketData(null);
    } finally {
      setIsLoading(false);
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "ACTIVE":
        return GlobalStyles.colors.green;
      case "CONSUMED":
        return GlobalStyles.colors.mustard;
      case "EXPIRED":
        return GlobalStyles.colors.red;
      default:
        return GlobalStyles.colors.black;
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case "ACTIVE":
        return "Ticket valid and not consumed";
      case "CONSUMED":
        return "Ticket marked as consumed";
      case "EXPIRED":
        return "Ticket expiry date is in the past";
      default:
        return status;
    }
  };

  return (
    <Box w="100%" flex={1} pt={4} pb={10}>
      <VStack w="100%" space={4}>
        <Center>
          <VStack w={["90%", 450, 520]} space={4} px={4}>
            <Text
              fontSize={[16, 17, 18]}
              fontWeight="600"
              color={GlobalStyles.colors.blue}
              fontFamily={GlobalStyles.text.fontFamily}
              textAlign="center"
            >
              Ticket Verification
            </Text>

            <Box>
              <Text
                fontWeight="400"
                mb={2}
                color={GlobalStyles.colors.black}
                fontFamily={GlobalStyles.text.fontFamily}
                fontSize={["14px", "15px", "16px"]}
              >
                Enter Ticket ID
              </Text>
              <HStack space={2}>
                <Input
                  flex={1}
                  value={ticketId}
                  onChangeText={setTicketId}
                  borderColor={GlobalStyles.colors.mustard}
                  borderWidth={1}
                  borderRadius={6}
                  bg={GlobalStyles.colors.white}
                  _focus={{ borderColor: GlobalStyles.colors.mustard }}
                  fontFamily={GlobalStyles.text.fontFamily}
                  fontSize={["sm", "md", "md"]}
                  py={3}
                  placeholder="Enter ticket ID"
                  keyboardType="numeric"
                />
                <Pressable onPress={fetchTicketStatus} disabled={isLoading}>
                  <Box
                    borderRadius={6}
                    overflow="hidden"
                    borderWidth={1}
                    borderColor={GlobalStyles.colors.blue}
                    h="100%"
                    justifyContent="center"
                  >
                    <LinearGradient
                      colors={[
                        GlobalStyles.colors.gradientBlueStart,
                        GlobalStyles.colors.gradientBlueEnd,
                      ]}
                      start={{ x: 0, y: 0 }}
                      end={{ x: 1, y: 0 }}
                      style={{
                        paddingHorizontal: 20,
                        paddingVertical: 12,
                        height: "100%",
                        justifyContent: "center",
                      }}
                    >
                      {isLoading ? (
                        <Spinner color={GlobalStyles.colors.mustard} size="sm" />
                      ) : (
                        <Text
                          color={GlobalStyles.colors.mustard}
                          fontWeight="600"
                          fontSize="15px"
                          fontFamily={GlobalStyles.text.fontFamily}
                        >
                          Verify
                        </Text>
                      )}
                    </LinearGradient>
                  </Box>
                </Pressable>
              </HStack>
            </Box>

            {ticketData && (
              <Box position="relative" alignItems="center" mt={4}>
                <Box position="absolute" top={-40} zIndex={10}>
                  <Image
                    source={verifyIcon}
                    alt="Verify Badge"
                    style={{ width: 80, height: 80 }}
                    resizeMode="contain"
                  />
                </Box>

                <Box
                  w="100%"
                  bg={GlobalStyles.colors.white}
                  borderRadius={12}
                  px={[6, 8, 8]}
                  py={4}
                  pt={10}
                  mb={10}
                  style={
                    Platform.OS === "web"
                      ? { boxShadow: "0px 4px 4px 0px #00000040" }
                      : {
                          shadowColor: "#000",
                          shadowOffset: { width: 0, height: 4 },
                          shadowOpacity: 0.25,
                          shadowRadius: 4,
                          elevation: 4,
                        }
                  }
                >
                  <Text
                    fontSize={[16, 17, 18]}
                    fontWeight="400"
                    color={GlobalStyles.colors.black}
                    fontFamily={GlobalStyles.text.fontFamily}
                    mb={4}
                    textAlign="center"
                  >
                    Ticket Details
                  </Text>

                  <VStack space={2.5}>
                    <HStack justifyContent="space-between" alignItems="center">
                      <Text
                        fontSize={[14, 15, 15]}
                        fontWeight="400"
                        color={GlobalStyles.colors.black}
                        fontFamily={GlobalStyles.text.fontFamily}
                      >
                        Ticket Name:
                      </Text>
                      <Text
                        fontSize={[14, 15, 15]}
                        fontWeight="400"
                        color={GlobalStyles.colors.black}
                        fontFamily={GlobalStyles.text.fontFamily}
                      >
                        {ticketData.ticket_name}
                      </Text>
                    </HStack>

                    <HStack justifyContent="space-between" alignItems="center">
                      <Text
                        fontSize={[14, 15, 15]}
                        fontWeight="400"
                        color={GlobalStyles.colors.black}
                        fontFamily={GlobalStyles.text.fontFamily}
                      >
                        Company:
                      </Text>
                      <Text
                        fontSize={[14, 15, 15]}
                        fontWeight="400"
                        color={GlobalStyles.colors.black}
                        fontFamily={GlobalStyles.text.fontFamily}
                      >
                        {ticketData.company_name}
                      </Text>
                    </HStack>

                    <HStack justifyContent="space-between" alignItems="center">
                      <Text
                        fontSize={[14, 15, 15]}
                        fontWeight="400"
                        color={GlobalStyles.colors.black}
                        fontFamily={GlobalStyles.text.fontFamily}
                      >
                        Type:
                      </Text>
                      <Text
                        fontSize={[14, 15, 15]}
                        fontWeight="400"
                        color={GlobalStyles.colors.black}
                        fontFamily={GlobalStyles.text.fontFamily}
                      >
                        {ticketData.ticket_type}
                      </Text>
                    </HStack>

                    <HStack justifyContent="space-between" alignItems="center">
                      <Text
                        fontSize={[14, 15, 15]}
                        fontWeight="400"
                        color={GlobalStyles.colors.black}
                        fontFamily={GlobalStyles.text.fontFamily}
                      >
                        Total Tickets:
                      </Text>
                      <Text
                        fontSize={[14, 15, 15]}
                        fontWeight="400"
                        color={GlobalStyles.colors.black}
                        fontFamily={GlobalStyles.text.fontFamily}
                      >
                        {ticketData.total_tickets}
                      </Text>
                    </HStack>

                    <HStack justifyContent="space-between" alignItems="center">
                      <Text
                        fontSize={[14, 15, 15]}
                        fontWeight="400"
                        color={GlobalStyles.colors.black}
                        fontFamily={GlobalStyles.text.fontFamily}
                      >
                        Available:
                      </Text>
                      <Text
                        fontSize={[14, 15, 15]}
                        fontWeight="400"
                        color={GlobalStyles.colors.black}
                        fontFamily={GlobalStyles.text.fontFamily}
                      >
                        {ticketData.total_available}
                      </Text>
                    </HStack>

                    {ticketData.buying_date && (
                      <HStack justifyContent="space-between" alignItems="center">
                        <Text
                          fontSize={[14, 15, 15]}
                          fontWeight="400"
                          color={GlobalStyles.colors.black}
                          fontFamily={GlobalStyles.text.fontFamily}
                        >
                          Buying Date:
                        </Text>
                        <Text
                          fontSize={[14, 15, 15]}
                          fontWeight="400"
                          color={GlobalStyles.colors.black}
                          fontFamily={GlobalStyles.text.fontFamily}
                        >
                          {new Date(ticketData.buying_date).toLocaleDateString()}
                        </Text>
                      </HStack>
                    )}

                    <HStack justifyContent="space-between" alignItems="center">
                      <Text
                        fontSize={[14, 15, 15]}
                        fontWeight="400"
                        color={GlobalStyles.colors.black}
                        fontFamily={GlobalStyles.text.fontFamily}
                      >
                        Expiry Date:
                      </Text>
                      <Text
                        fontSize={[14, 15, 15]}
                        fontWeight="400"
                        color={GlobalStyles.colors.black}
                        fontFamily={GlobalStyles.text.fontFamily}
                      >
                        {new Date(ticketData.expiry_date).toLocaleDateString()}
                      </Text>
                    </HStack>

                    <Box
                      borderTopWidth={1}
                      borderTopColor="#E0E0E0"
                      pt={3}
                      mt={2}
                    >
                      <VStack space={2}>
                        <HStack justifyContent="space-between" alignItems="center">
                          <Text
                            fontSize={[14, 15, 15]}
                            fontWeight="600"
                            color={GlobalStyles.colors.black}
                            fontFamily={GlobalStyles.text.fontFamily}
                          >
                            Status:
                          </Text>
                          <Box
                            bg={getStatusColor(ticketData.status)}
                            px={3}
                            py={1}
                            borderRadius={6}
                          >
                            <Text
                              fontSize={[13, 14, 14]}
                              fontWeight="600"
                              color={GlobalStyles.colors.white}
                              fontFamily={GlobalStyles.text.fontFamily}
                            >
                              {ticketData.status}
                            </Text>
                          </Box>
                        </HStack>

                        <Text
                          fontSize={[12, 13, 13]}
                          fontWeight="300"
                          color="#666"
                          fontStyle="italic"
                          fontFamily={GlobalStyles.text.fontFamily}
                          textAlign="center"
                        >
                          {getStatusText(ticketData.status)}
                        </Text>

                        {ticketData.status !== "EXPIRED" && (
                          <HStack
                            justifyContent="space-between"
                            alignItems="center"
                            mt={3}
                            bg="#F5F5F5"
                            px={3}
                            py={2}
                            borderRadius={8}
                          >
                            <Text
                              fontSize={[14, 15, 15]}
                              fontWeight="500"
                              color={GlobalStyles.colors.black}
                              fontFamily={GlobalStyles.text.fontFamily}
                            >
                              Ticket has been consumed
                            </Text>
                            <Pressable>
                              <Box
                                w={22}
                                h={22}
                                borderRadius={4}
                                borderWidth={2}
                                borderColor={
                                  ticketData.status === "CONSUMED"
                                    ? GlobalStyles.colors.mustard
                                    : "#CCC"
                                }
                                bg={
                                  ticketData.status === "CONSUMED"
                                    ? GlobalStyles.colors.mustard
                                    : "transparent"
                                }
                                alignItems="center"
                                justifyContent="center"
                              >
                                {ticketData.status === "CONSUMED" && (
                                  <Icon
                                    as={Ionicons}
                                    name="checkmark"
                                    size="sm"
                                    color={GlobalStyles.colors.white}
                                  />
                                )}
                              </Box>
                            </Pressable>
                          </HStack>
                        )}
                      </VStack>
                    </Box>
                  </VStack>
                </Box>
              </Box>
            )}
          </VStack>
        </Center>
      </VStack>
    </Box>
  );
};

const TicketManager = ({ onBack }) => {
  const toast = useToast();
  const user = useSelector((state) => state.user?.user);
  const [formStep, setFormStep] = useState("form");
  const [newTicket, setNewTicket] = useState(null);
  const [ticketsList, setTicketsList] = useState([]);
  const [isLoadingTickets, setIsLoadingTickets] = useState(false);
  const [hasShownErrorToast, setHasShownErrorToast] = useState(false);

  const [createBtnColor, setCreateBtnColor] = useState(
    GlobalStyles.colors.mustard,
  );
  const [deleteBtnColor, setDeleteBtnColor] = useState(
    GlobalStyles.colors.blue,
  );
  const [analyticsBtnColor, setAnalyticsBtnColor] = useState(
    GlobalStyles.colors.blue,
  );
  const [verifyBtnColor, setVerifyBtnColor] = useState(
    GlobalStyles.colors.blue,
  );

  const [currentTab, setCurrentTab] = useState("create");

  const [showScrollBtn, setShowScrollBtn] = useState(false);
  const scrollRef = useRef(null);

  useEffect(() => {
    if (user?.token) {
      axios.defaults.headers.common = {
        Authorization: `Bearer ${user.token}`,
      };
    }
  }, [user]);

  const fetchTickets = useCallback(
    async (showToastOnError = false) => {
      try {
        setIsLoadingTickets(true);

        const apiClient = axios.create({
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
          timeout: 5000,
        });

        const response = await apiClient.get(apiBaseUrl);

        if (response.data.tickets) {
          const formattedTickets = response.data.tickets.map((ticket) => ({
            id: ticket.id,
            name: ticket.name,
            title: ticket.name,
            companyName: ticket.company_name,
            count: ticket.total_tickets,
            value: ticket.ticket_value,
            valueUSD: ticket.ticket_value_usd,
            valueLocal: ticket.ticket_value_local,
            currency: ticket.currency,
            expiry: ticket.expiry_date,
            created: ticket.total_tickets,
            used: ticket.total_tickets - ticket.total_available,
            qrCode: ticket.qr_code,
          }));
          setTicketsList(formattedTickets);
        }
      } catch (error) {
        console.error("Error fetching tickets:", error);

        if (showToastOnError && !hasShownErrorToast) {
          setHasShownErrorToast(true);
          toast.show({
            render: () => (
              <Toast
                color={GlobalStyles.colors.red}
                message="Unable to load tickets. Please check your connection."
              />
            ),
            placement: "top",
            duration: 2000,
          });
        }
      } finally {
        setIsLoadingTickets(false);
      }
    },
    [user, toast, hasShownErrorToast],
  );

  const handleGoHome = () => {
    setCurrentTab("create");
    setFormStep("form");
    setCreateBtnColor(GlobalStyles.colors.mustard);
    setDeleteBtnColor(GlobalStyles.colors.blue);
    setAnalyticsBtnColor(GlobalStyles.colors.blue);
    setVerifyBtnColor(GlobalStyles.colors.blue);
  };

  const changeTab = (tabType) => {
    if (tabType === "create") {
      setCreateBtnColor(GlobalStyles.colors.mustard);
      setDeleteBtnColor(GlobalStyles.colors.blue);
      setAnalyticsBtnColor(GlobalStyles.colors.blue);
      setVerifyBtnColor(GlobalStyles.colors.blue);
      setCurrentTab("create");
      setFormStep("form");
    } else if (tabType === "delete") {
      setCreateBtnColor(GlobalStyles.colors.blue);
      setDeleteBtnColor(GlobalStyles.colors.mustard);
      setAnalyticsBtnColor(GlobalStyles.colors.blue);
      setVerifyBtnColor(GlobalStyles.colors.blue);
      setCurrentTab("delete");
      if (ticketsList.length === 0) {
        fetchTickets(true);
      }
    } else if (tabType === "analytics") {
      setCreateBtnColor(GlobalStyles.colors.blue);
      setDeleteBtnColor(GlobalStyles.colors.blue);
      setAnalyticsBtnColor(GlobalStyles.colors.mustard);
      setVerifyBtnColor(GlobalStyles.colors.blue);
      setCurrentTab("analytics");
      if (ticketsList.length === 0) {
        fetchTickets(true);
      }
    } else if (tabType === "verify") {
      setCreateBtnColor(GlobalStyles.colors.blue);
      setDeleteBtnColor(GlobalStyles.colors.blue);
      setAnalyticsBtnColor(GlobalStyles.colors.blue);
      setVerifyBtnColor(GlobalStyles.colors.mustard);
      setCurrentTab("verify");
    }
  };

  const addTicket = (ticket) => {
    setTicketsList((prev) => [...prev, ticket]);
    setNewTicket(ticket);
    setFormStep("generated");
    fetchTickets(false);
  };

  const removeTicket = (ticketId) => {
    setTicketsList((prev) => prev.filter((ticket) => ticket.id !== ticketId));
    fetchTickets(false);
  };

  const goToTop = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollTo({ y: 0, animated: true });
    }
  };

  const checkScroll = (event) => {
    const scrollY = event.nativeEvent.contentOffset.y;
    setShowScrollBtn(scrollY > 100);
  };

  return (
    <>
      <ScrollView
        ref={scrollRef}
        onScroll={checkScroll}
        scrollEventThrottle={16}
        flex={1}
      >
        <Center>
          <Stack
            mt={6}
            w={["92%", "85%", 750]}
            alignItems="center"
            justifyContent="center"
          >
            {onBack && (
              <HStack w="100%" mb={4} px={[2, 4, 4]}>
                <Pressable onPress={onBack}>
                  <HStack alignItems="center" space={2}>
                    <Text
                      color={GlobalStyles.colors.blue}
                      fontWeight="600"
                      fontSize={[15, 16, 16]}
                      fontFamily={GlobalStyles.text.fontFamily}
                    >
                      ← Back to Services
                    </Text>
                  </HStack>
                </Pressable>
              </HStack>
            )}

            <Stack
              mb={5}
              w={["100%", "100%", 650]}
              justifyContent="center"
              flexDirection="row"
              flexWrap="wrap"
            >
              <Button
                size="sm"
                mx={1}
                my={1}
                variant="solid"
                px="4"
                bg={GlobalStyles.colors.white}
                borderColor={createBtnColor}
                borderWidth={2}
                borderRadius={40}
                _hover={{ bg: GlobalStyles.colors.grey }}
                onPress={() => changeTab("create")}
              >
                <Text
                  fontWeight="bold"
                  fontFamily={GlobalStyles.text.fontFamily}
                  color={createBtnColor}
                  fontSize={[13, 14, 14]}
                >
                  Create Ticket
                </Text>
              </Button>

              <Button
                size="sm"
                mx={1}
                my={1}
                variant="solid"
                px="4"
                bg={GlobalStyles.colors.white}
                borderColor={deleteBtnColor}
                borderWidth={2}
                borderRadius={40}
                _hover={{ bg: GlobalStyles.colors.grey }}
                onPress={() => changeTab("delete")}
              >
                <Text
                  fontWeight="bold"
                  fontFamily={GlobalStyles.text.fontFamily}
                  color={deleteBtnColor}
                  fontSize={[13, 14, 14]}
                >
                  Delete Ticket
                </Text>
              </Button>

              <Button
                size="sm"
                mx={1}
                my={1}
                variant="solid"
                px="4"
                bg={GlobalStyles.colors.white}
                borderColor={analyticsBtnColor}
                borderWidth={2}
                borderRadius={40}
                _hover={{ bg: GlobalStyles.colors.grey }}
                onPress={() => changeTab("analytics")}
              >
                <Text
                  fontWeight="bold"
                  fontFamily={GlobalStyles.text.fontFamily}
                  color={analyticsBtnColor}
                  fontSize={[13, 14, 14]}
                >
                  Analytics
                </Text>
              </Button>

              <Button
                size="sm"
                mx={1}
                my={1}
                variant="solid"
                px="4"
                bg={GlobalStyles.colors.white}
                borderColor={verifyBtnColor}
                borderWidth={2}
                borderRadius={40}
                _hover={{ bg: GlobalStyles.colors.grey }}
                onPress={() => changeTab("verify")}
              >
                <Text
                  fontWeight="bold"
                  fontFamily={GlobalStyles.text.fontFamily}
                  color={verifyBtnColor}
                  fontSize={[13, 14, 14]}
                >
                  Verify Tickets
                </Text>
              </Button>
            </Stack>

            {isLoadingTickets &&
              (currentTab === "delete" || currentTab === "analytics") &&
              ticketsList.length === 0 ? (
              <Center py={10}>
                <Spinner color={GlobalStyles.colors.blue} size="lg" />
                <Text
                  mt={3}
                  color={GlobalStyles.colors.black}
                  fontFamily={GlobalStyles.text.fontFamily}
                >
                  Loading tickets...
                </Text>
              </Center>
            ) : (
              <>
                {currentTab === "create" && formStep === "form" && (
                  <TicketCreate onCreated={addTicket} />
                )}

                {currentTab === "create" && formStep === "generated" && (
                  <VStack space={4} alignItems="center" w="100%">
                    <TicketGenerated ticket={newTicket} onHome={handleGoHome} />
                    <Pressable onPress={() => setFormStep("form")}>
                      <Text
                        color={GlobalStyles.colors.blue}
                        fontWeight="600"
                        fontSize={[15, 16, 16]}
                        textDecoration="underline"
                        fontFamily={GlobalStyles.text.fontFamily}
                      >
                        Create Another Ticket
                      </Text>
                    </Pressable>
                  </VStack>
                )}

                {currentTab === "delete" && (
                  <TicketDelete
                    tickets={ticketsList}
                    onDeleted={removeTicket}
                    onHome={handleGoHome}
                  />
                )}

                {currentTab === "analytics" && (
                  <TicketAnalytics tickets={ticketsList} onHome={handleGoHome} />
                )}

                {currentTab === "verify" && <TicketVerify onHome={handleGoHome} />}
              </>
            )}
          </Stack>
        </Center>
      </ScrollView>

      {showScrollBtn && (
        <IconButton
          position="absolute"
          bottom={10}
          right={10}
          borderRadius="full"
          bg={GlobalStyles.colors.blue}
          _pressed={{ bg: "gray.500" }}
          icon={<ChevronUpIcon color="white" size={6} />}
          onPress={goToTop}
        />
      )}
    </>
  );
};

export {
  TicketManager,
  TicketCreate,
  TicketDelete,
  TicketAnalytics,
  TicketVerify,
};
export default TicketManager;